import React, { FC } from 'react';
import { LightHeader } from '../../header/light/LightHeader';

export const PageLayoutFallback: FC = () => (
  <LightHeader source="page-fallback" hideLogoTitle />
);
